import { Country, Currency, State } from "../global/types"
import { ProductPrice } from "../products/types"

export type Cart = {
  uuid: string
  promocode: {
    id: string
    code: string
  } | null
  itemTotal: number
  billingAddress: {
    name: string
    address: string | null
    pincode: string | null
    city: string
    country: string
    state: string
    uuid: string
  } | null
  promocodeDiscount: number
  totalTaxCharged: number
  cartTotal: number
  currency: Pick<Currency, "code" | "symbol">
  country: Pick<Country, "name" | "isoCode">
  cartTax: {
    tax: {
      rate: number
      name: string
    }
    taxAmount: number
  }[]
  cartItems: {
    productId: number
    productName: string
    price: ProductPrice
    image: string
  }[]
}

export type SavedAddress = {
  id: number
  country: Pick<Country, "name" | "uuid" | "isoCode">
  state: Pick<State, "name" | "uuid" | "isoCode">
  uuid: string
  name: string
  address: string | null
  pincode: string | null
  city: string
  user: string
}

export enum PaymentMethodType {
  juspay = "JUSPAY_1",
  stripe = "STRIPE_1",
  stripeSubscriptionLink = "STRIPE_8",
  razorpay = "RZP_1",
  razorpayPaymentLink = "RZP_2",
  razorpaySubscription = "RZP_8",
}

export type PaymentMethod = {
  paymentMethodId: PaymentMethodType
  paymentMethodDetails: {
    orderId: string
    amount: number
    clientSecret?: string
    paymentLink?: string
    paymentLinkId?: string
    paymentLinkUrl?: string
    mandateLinkId?: string
    mandateUrl?: string
  }

  paymentGatewayOrder?: {
    isFreeOrder: boolean
  }
  orderPaymentPlanId: string
  createdAt: string
  id: string
}

export enum RefundStatus {
  refundInitiated = "refund_initiated",
  refunded = "refunded",
}

export enum PaymentStatus {
  notInitiated = "not_initiated",
  inProgress = "in_progress",
  completed = "completed",
  cancelled = "cancelled",
  overdue = "overdue",
}
